import React, { useState, useEffect } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import {Step3Schema} from './schemas'
import Grid from '@material-ui/core/Grid';
import SelectField from '../../components/FormFields/SelectField';
import InputField from '../../components/FormFields/InputField';
import { makeStyles } from '@material-ui/core/styles';
import {Button,CardActions }  from '@material-ui/core';
import axiosInstance from '../../axios-orders';


const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));
const sex=[
  {
    value: 'MALE',
    label: 'Masculino'
  },
  {
    value: 'FEMELE',
    label: 'Femenino'
  }
];
//const categorias_docentes= nomenclatureService.getAllCountries();
const categorias_docentes=[
  {
    value: 1,
    label: 'Asistente'
  },
  {
    value: 2,
    label: 'Instructor'
  },
  {
    value: 3,
    label: 'Auxiliar'
  },
  {
    value: 4,
    label: 'Titular'
  }
];

export const Step3 = ({submit, setData, data}) => {
  const classes = useStyles(); 
  const [customers,setCustomers] = useState([]);
  
 /* useEffect(() => {
     let  token  = JSON.parse(localStorage.getItem('user'));
     
     axiosInstance().get('/api/nomenclator/docentcategory/categories').then(res => {
         const customers = res.data;         
         const listItems = [];
         customers.forEach(customer => {
            listItems.push({
                'value': customer.id,
                'label': customer.category
            });
         });      
         
        setCustomers(listItems);       
       }).catch(console.error());

 }, []); */
  return (
    <Formik
      initialValues={data}
      validationSchema={Step3Schema}
      onSubmit={(values) => {
        submit(1)
        setData({...values, ...data})
        
      }}
    >
      <Form>      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <InputField
            required
            id='FirstName'
            name='FirstName'
            label='Nombre'
            fullWidth
            autoComplete="given-name"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            required
            id='LastName'
            name='LastName'
            label='Apellidos'
            fullWidth
            autoComplete="family-name"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={2}>
        <SelectField
            name='gender'
            label='Sexo'
            data={sex}
            fullWidth
            variant="outlined"
          />
        </Grid>       
        <Grid item xs={12} sm={6}>
          <InputField required id='ci' name='ci' label="No. C. Identidad" fullWidth  variant="outlined"/>
        </Grid>
        <Grid item xs={12} sm={8}>
          <InputField
            required
            id='address'
            name='address'
            label='Dirección'
            fullWidth  
            variant="outlined"          
          />
        </Grid> 
        <Grid item xs={12} sm={4}>
          <InputField   id='phone' name='phone' label='Teléfono' fullWidth  variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={5}>
          <InputField  required id='graduado' name='graduado' label='Graduado de' fullWidth  variant="outlined"/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InputField required id='graduationYear' name='graduationYear' label='Año de Graduación' fullWidth   variant="outlined"/>
        </Grid>               
        <Grid item xs={12} sm={4}>
          <InputField   id='workplace' name='workplace' label='Centro de trabajo' fullWidth  variant="outlined"/>
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputField  id='position' name='position' label='Cargo' fullWidth  variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputField  id='organism' name='organism' label='Organismo' fullWidth variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={8}>
          <InputField            
            id='city'
            name='city'
            label='Dirección del Centro de Trabajo'
            fullWidth    
            variant="outlined"       
          />
        </Grid>        
        <Grid item xs={12} sm={4}>
          <InputField   id='workphone' name='workphone' label="Télefono del Centro de Trabajo" fullWidth  variant="outlined" />
        </Grid>       
      </Grid>   
      <span> 
        <Button
                    //disabled={isSubmitting}
                    type="submit"
                    variant="contained"                    
                    color="primary"
                    //onClick={_handleSubmit}
                    className={classes.button}
                  >     Siguiente  
        </Button>
      
        </span>   
      </Form>
    </Formik>
    
  );
};